export const fetchIpAddress = async (setUserIP) => {
  const response = await fetch("https://api.ipify.org?format=json");
  const data = await response.json();
  setUserIP(data.ip);
};
